<template>
  <v-container>
    <h2>Create customer</h2>
    <v-row>
      <v-col lg="10" md="12" sm="12">
        <v-row>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="customer.firstname"
              label="Firstname"
              :rules="[rules.require]"
              outlined
              dense
            />
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="customer.lastname"
              label="Lastname"
              outlined
              dense
            />
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="customer.display_name"
              label="Display name/nickname"
              outlined
              dense
            />
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="customer.email"
              label="Email"
              outlined
              dense
            />
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="customer.phone_number"
              label="Phone number"
              outlined
              dense
            />
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="customer.line_id"
              label="Line ID"
              outlined
              dense
            />
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="customer.facebook_name"
              label="Facebook name"
              outlined
              dense
            />
          </v-col>
        </v-row>
        <v-divider></v-divider>
        <div class="text-left">
          <v-btn
            class="mx-2"
            small
            color="orange"
            dark
            @click="updateCustomer"
          >
            Update
          </v-btn>
          <v-btn
            class="mx-2"
            small
            exact
            :to="{ name: 'customer-list' }"
          >
            Cancel
          </v-btn>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { authHeader } from '../../../_helpers';
export default {
  name: "CustomerEdit",
  components: {

  },
  data: () => ({
    customer_id: null,
    customer: {
      firstname: null,
      lastname: null,
      display_name: null,
      email: null,
      phone_number: null,
      line_id: null,
      facebook_name: null
    },
    rules: {
      profile_image: value => !value || value.size < 2000000 || 'Avatar size should be less than 2 MB!',
      require: value => !!value || 'Please fill in information',
      personal_id: value => !value || value.length < 14 || 'Personal ID must have 13 digits',
    },
  }),
  async mounted () {
    let id = this.$route.params.id
    await this.getCustomer(id)
  },
  methods: {
    async updateCustomer () {
      try {
        await this.$http.put(`/back-office/customers/${this.customer_id}`, this.customer, authHeader())
        this.$router.push({ name: 'customer-list'})
      } catch (err) {
        console.log(err)
        alert('Something went wrong')
      }
    },
    async getCustomer (id) {
      this.customer_id = id
      try {
        const result = await this.$http.get(`/back-office/customers/${this.customer_id}`, authHeader())
        this.customer.firstname = result.data.firstname
        this.customer.lastname = result.data.lastname
        this.customer.display_name = result.data.display_name
        this.customer.email = result.data.email
        this.customer.phone_number = result.data.phone_number
        this.customer.line_id = result.data.line_id
        this.customer.facebook_name = result.data.facebook_name
      } catch (err) {
        console.log(err)
        alert('Something went wrong')
      }
    },
    requireField () {
      if (!this.customer.firstname) {
        alert('Please fill in firstname')
        return false;
      }
      return true
    }
  },
};
</script>
